import axios from "axios";
import { Parcel } from "@/models/Parcel";

export default {
  state: {
    center: null,
    zoom: null,
    newParcel: undefined,
    parcelWoj: undefined,
    parcelPowiat: undefined,
    parcelGmina: undefined,
    parcelsFilters: [
      {
        attribute: "",
        operator: "==",
        value: "",
        mergeOperator: "OR"
      }
    ],
    parcelMapView: undefined,
    newlyAddedParcel: null
  },
  actions: {
    async deleteParcel(ctx, payload) {
      try {
        const { id } = payload;
        const res = await axios.delete(`/parcels/${id}`);
        return res;
      } catch (error) {
        console.log(`deleteParcel -> error`, error);
        return error;
      }
    },
    copyParcel(ctx, id) {
      const url = `/parcels/${id}/copy`;
      return axios
        .post(url)
        .then(r => {
          if (r) {
            return r;
          }
        })
        .catch(e => {
          return e;
        });
    },
    postNewParcel(ctx, payload) {
      return axios
        .post(`/parcels`, payload)
        .then(r => {
          if (r) {
            return r;
          }
        })
        .catch(e => {
          return e.response;
        });
    },
    downloadAttachment(ctx, id) {
      return axios
        .get(`/files/${id}`, {
          responseType: "blob"
        })
        .then(r => {
          if (r) {
            return r;
          } else {
            return false;
          }
        })
        .catch(e => {
          return e;
        });
    },
    editParcel(ctx, payload) {
      const url = `/parcels/${payload.id}`;
      return axios
        .put(url, payload)
        .then(r => {
          if (r) {
            return r;
          }
        })
        .catch(e => {
          return e;
        });
    },
    getParcelUldkByID(ctx, payload) {
      const {id, precint, number} = payload;
      const idParam = id || `${precint}.${number}`;
      const url = `https://uldk.gugik.gov.pl/?request=GetParcelByIdOrNr&id=${
        idParam
      }&result=geom_wkt,voivodeship,county,commune,parcel,region,teryt`;
      return axios
        .get(url)
        .then(r => {
          if (r) {
            return r;
          } else {
            return false;
          }
        })
        .catch(err => {
          return err.response;
        });
    },
    getParcelULDK(ctx, coords) {
      const url = `https://uldk.gugik.gov.pl/?request=GetParcelByXY&xy=${
        coords[0]
      },${
        coords[1]
      },2180&result=geom_wkt,voivodeship,county,commune,parcel,region,teryt`;
      return axios
        .get(url)
        .then(r => {
          if (r) {
            return r;
          } else {
            return false;
          }
        })
        .catch(err => {
          return err;
        });
    },
    getParcels(ctx, payload) {
      return axios
        .get("/parcels", {
          params: payload
        })
        .then(r => {
          if (r) {
            return r.data.parcels.map(parcel => new Parcel(parcel));
          }
          return false;
        })
        .catch(err => {
          return err.response.data.message;
        });
    },
    getParcel(ctx, { id, params }) {
      return axios
        .get(`/parcels/${id}`, {
          params
        })
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(err => {
          return err.response.data;
        });
    },
    getParcelComments(ctx, id) {
      return axios
        .get(`/comments/parcel/${id}`)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(e => {
          return e.response.data.message;
        });
    },
    getParcelAttachments(ctx, id) {
      return axios
        .post(`/files/parcel/${id}`)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(e => {
          return e.response.data.message;
        });
    },
    updateParcelGeom(ctx, oid) {
      return axios
        .put(`/parcels/${oid}`)
        .then(r => {
          if (r) {
            return r;
          } else {
            return false;
          }
        })
        .catch(err => {
          return err.response.data.message;
        });
    },
    getPRG(ctx, payload) {
      let url = `/prg/${payload.level}`;
      return axios
        .get(url, {
          params: payload.params
        })
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(err => {
          return err.response.data;
        });
    },
    getOfferParcels(ctx, payload) {
      return axios
        .get("/parcels_offers", {
          params: payload
        })
        .then(r => {
          if (r) {
            return r.data.parcels.map(parcel => new Parcel(parcel));
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    deleteParcelFromOffer(ctx, data) {
      return axios
        .delete(`/parcels_offers`, {
          params: data
        })
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error;
        });
    }
  },
  mutations: {
    setNewParcel(state, newParcel) {
      state.newParcel = newParcel;
    },
    setParcelWoj(state, woj) {
      state.parcelWoj = woj;
    },
    setParcelPowiat(state, powiat) {
      state.parcelPowiat = powiat;
    },
    setParcelGmina(state, gmina) {
      state.parcelGmina = gmina;
    },
    setParcelsFilters(state, filters) {
      state.parcelsFilters = filters;
    },
    setParcelMapView(state, mapView) {
      state.parcelMapView = mapView;
    },
    setNewlyAddedParcel(state, value) {
      state.newlyAddedParcel = value;
    }
  },
  getters: {
    getNewParcel(state) {
      return state.newParcel;
    },
    getParcelWoj(state) {
      return state.parcelWoj;
    },
    getParcelPowiat(state) {
      return state.parcelPowiat;
    },
    getParcelGmina(state) {
      return state.parcelGmina;
    },
    getParcelsFilters(state) {
      return state.parcelsFilters;
    },
    getParcelMapView(state) {
      return state.parcelMapView;
    },
    getNewlyAddedParcel(state) {
      return state.newlyAddedParcel;
    }
  }
};
